const NONE = 'None';
const CREATE = 'Create';
const EDIT = 'Edit';
const DUPLICATE = 'Duplicate';
const DELETE = 'Delete';
const ARCHIVE = 'Archive';
const VIEW = 'View';

export const AdminSidePanelAction = Object.freeze({
    [NONE]: 0,
    [CREATE]: 1,
    [EDIT]: 2,
    [DUPLICATE]: 3,
    [DELETE]: 4,
    [ARCHIVE]: 5,
    [VIEW]: 6,
});

const IndexedAdminSidePanelAction = Object.freeze({
    0: NONE,
    1: CREATE,
    2: EDIT,
    3: DUPLICATE,
    4: DELETE,
    5: ARCHIVE,
    6: VIEW,
});

export const AdminSidePanelActionNames = Object.freeze({
    None: IndexedAdminSidePanelAction[AdminSidePanelAction.None],
    Create: IndexedAdminSidePanelAction[AdminSidePanelAction.Create],
    Edit: IndexedAdminSidePanelAction[AdminSidePanelAction.Edit],
    Duplicate: IndexedAdminSidePanelAction[AdminSidePanelAction.Duplicate],
    Delete: IndexedAdminSidePanelAction[AdminSidePanelAction.Delete],
    Archive: IndexedAdminSidePanelAction[AdminSidePanelAction.Archive],
    View: IndexedAdminSidePanelAction[AdminSidePanelAction.View],
});